<template>
  <input type="text" ref="input" v-model="value" class="pci-number-editor" />
</template>

<script>
export default {
  name: 'NumberEditor',
  data () {
    return {
      value: null,
      cancelBeforeStart: false,
      select: true,
      withNegative: false,
      maxFraction: 2
    }
  },
  created () {
    this.cancelBeforeStart = this.params.charPress !== null
    this.withNegative = this.params.withNegative === true
    this.maxFraction = this.params.maxFraction === undefined ? 2 : this.params.maxFraction
    this.value = this.params.value
    // 46 = delete || 8 = backspace
    if (this.params.keyPress === 46 || this.params.keyPress === 8) {
      this.value = ''
    // 13 = enter
    } else if (this.params.keyPress === 13) {
      this.cancelBeforeStart = false
    } else if (this.params.charPress && '-1234567890.,'.indexOf(this.params.charPress) >= 0) {
      this.cancelBeforeStart = false
      // if (document.getElementById('evaluationModal') && /[2-9]/.test(this.params.charPress)) {
      //   this.value = '1'
      // } else {
      // }
      this.value = this.params.charPress === ',' || this.params.charPress === '.' ? '0.' : this.params.charPress
      this.value = this.params.charPress === '-' && !this.withNegative ? '' : this.value
      this.select = false
    }
  },
  mounted () {
    if (this.isCancelBeforeStart()) return

    if (this.params.value === '#NA#') {
      this.params.stopEditing()
      return
    }
    this.$nextTick(() => {
      this.$refs.input.focus()
      if (this.select) this.$refs.input.select()
      this.$refs.input
        .addEventListener('keydown', (evt) => {
          if (evt.key === 'ArrowUp') {
            this.params.api.stopEditing()
            const currentCell = this.params.api.getFocusedCell()
            const finalRowIndex = 0

            if (currentCell) {
              if (currentCell.rowIndex === finalRowIndex) {
                this.parmas.api.setFocusedCell(currentCell.rowIndex, currentCell.column)
              } else {
                this.params.api.setFocusedCell(currentCell.rowIndex - 1, currentCell.column)
              }
            }
          } else if (evt.key === 'ArrowDown') {
            this.params.api.stopEditing()
            const currentCell = this.params.api.getFocusedCell()
            const finalRowIndex = this.params.api.rowModel.getRowCount() - 1

            if (currentCell) {
              if (currentCell.rowIndex === finalRowIndex) {
                this.parmas.api.setFocusedCell(currentCell.rowIndex, currentCell.column)
              } else {
                this.params.api.setFocusedCell(currentCell.rowIndex + 1, currentCell.column)
              }
            }
          } else {
            const vl = this.$refs.input.value.slice(0, this.$refs.input.selectionStart) + this.$refs.input.value.slice(this.$refs.input.selectionEnd)
            const matchFraction = new RegExp('(\\d?\\.\\d{' + this.maxFraction + '}$)', 'g')
            if (/\.|,/.test(evt.key) && vl.includes('.')) {
              evt.stopPropagation()
              evt.preventDefault()
            } else if (/,/.test(evt.key)) {
              this.$refs.input.value = this.$refs.input.value.slice(0, this.$refs.input.selectionStart) + '.' + this.$refs.input.value.slice(this.$refs.input.selectionEnd)
              this.$refs.input.selectionStart = this.$refs.input.selectionEnd
              evt.stopPropagation()
              evt.preventDefault()
            } else if ((!/(Backspace|Delete|Esc|Enter|Tab|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|[0-9]|\.|-)/.test(evt.key)) ||
                (/([0-9]|\.)/.test(evt.key) && matchFraction.test(this.$refs.input.value) &&
                  (this.$refs.input.selectionStart === this.$refs.input.selectionEnd))) {
              evt.stopPropagation()
              evt.preventDefault()
            } else if ((!this.withNegative && evt.key === '-') ||
              (this.withNegative && evt.key === '-' && (vl.includes('-') || this.$refs.input.value.length > 0))) {
              evt.stopPropagation()
              evt.preventDefault()
            }
          }
        })
    })
  },
  methods: {
    getValue () {
      if (this.params.colDef.type === 'integerColumn') {
        this.value = Math.round(this.value)
      }
      return this.value
    },
    isCancelBeforeStart () {
      return this.cancelBeforeStart
    }
  }
}
</script>

<style scoped>
.pci-number-editor {
  border-width: 1px;
  border-style: solid;
  border-color: #babfc7;
  border-color: var(--ag-input-border-color, var(--ag-border-color, #babfc7));
  margin: 0;
  padding: 0 10px 0 0;
  border: 0;
  outline: 0;
  width: 100%;
  height: 100%;
  text-align: right;
}

.pci-date-editor:focus-visible {
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/components/NumberEditor.vue